import React from 'react'

const TitleSection = ({ title }: { title: string }) => {
    return (
        <h3 className='text-[2.2rem] text-white w-fit px-[1rem] mx-auto text-center font-MontSemiBold'>{title}</h3>
    )
}

export default TitleSection